const translations = {
    connectionError: 'Connection Error',
    inviteFailed: 'Invite Failed',
    saveFailed: 'Save Failed'
};

export default translations;
